export default __webpack_public_path__ + "static/img/24.a5f4aec.png";